import { Temporal } from "./temporal.js";

//#region src/common/polyfill.ts
/**
* Setup Temporal polyfill for environments where Temporal is not natively available.
* This should be called once at application startup.
*
* When native Temporal support is widely available, this function will become a no-op
* and the polyfill dependency can be removed entirely without breaking consuming code.
*/
function setupTemporalPolyfill() {
	if (typeof globalThis.Temporal !== "undefined") return;
	globalThis.Temporal = Temporal;
}

//#endregion
export { setupTemporalPolyfill };